import { soFetch } from 'so-fetch';
import * as constants from './integration-constants';
import checkStatus from '../../utils/checkStatus';
import { merge, append, omit } from 'ramda';
import { fromJS } from 'immutable';
import queryString from 'query-string';

function callApi(tourPlanOptionID, startDate, endDate, contractWithMapping) {
  const url = `/proxy/integration/option`;
  return fetch(url, {
    method: 'put',
    credentials: 'same-origin',
    headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
    body: JSON.stringify({
      tourPlanOptionID,
      startDate,
      endDate,
      contractWithMapping: omit(['locationLogs'], contractWithMapping),
    }),
  })
  .then(checkStatus)
  .then(res => res.json());
}

function actionsForValidateMapping(key, status, payload, error) {
  return { type: constants.VALIDATE_MAPPING, status, key, payload, error };
}

function actionsForUpdateMappingStatus(key, status, error) {
  return { type: constants.VALIDATE_MAPPING_STATUS, status, key, error };
}

export const changeExportType = payload => ({ type: constants.CHANGE_INTEGRATION_EXPORT_TYPE, payload });

export const updateSettingsAction = payload => ({ type: constants.UPDATE_SETTINS, payload });

export const getSettings = () => {
  return dispatch => {
    dispatch(updateSettingsAction({ loadingSettings: true }));
    return fetch('/proxy/integration/settings', {
      method: 'get',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
    })
    .then(checkStatus)
    .then(res => res.json())
    .then(res => dispatch(updateSettingsAction(merge(res, { loadingSettings: false }))))
    .catch(() => dispatch(updateSettingsAction({ loadingSettings: false })));
  };
};

export const saveSettingsAction = (payload, successFlags) => {
  return dispatch => {
    dispatch(updateSettingsAction({ savingSettings: true }));
    return fetch(`/proxy/integration/settings`, {
      method: 'put',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(checkStatus)
      .then(() => dispatch(updateSettingsAction(merge({ savingSettings: false, ...payload }, successFlags))))
  };
};

export const updateMapping = (index, payload, updater) => {
  return dispatch => {
    dispatch(actionsForUpdateMappingStatus(index, 'validating'));
    return fetch(`/proxy/integration/mapping`, {
      method: 'put',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
    .then(() => {
      dispatch({
        type: constants.UPDATE_PRODUCT,
        payload: {
          index,
          updater,
        },
      })
      dispatch(actionsForUpdateMappingStatus(index, 'ready'));
    })
    .catch(err => {
      console.log(err.stack);
      dispatch(actionsForUpdateMappingStatus(index, 'failed', err.message));
    });
  };
};

export function checkIfHasRates(key, tourPlanOptionID, startDate, endDate, contract) {
  return dispatch => {
    dispatch({ type: constants.CHECK_RATES_STARTING });
    dispatch(actionsForUpdateMappingStatus(key, 'validating'));
    return callApi(tourPlanOptionID, startDate, endDate, contract)
    .then(res => {
      dispatch(actionsForUpdateMappingStatus(key, 'ready'));
      dispatch({
        type: constants.CHECK_IF_HAS_RATES,
        key,
        hasRates: res ? res.hasRates : false,
      });
    })
    .catch(err => {
      dispatch({
        type: constants.CHECK_IF_HAS_RATES_FAILED,
        key,
        hasRates: false,
      });
    });
  };
}

export function validateMapping(key, tourPlanOptionID, startDate, endDate, contract, productId) {
  return dispatch => {
    dispatch(actionsForUpdateMappingStatus(key, 'validating'));
    let response;
    return callApi(tourPlanOptionID, startDate, endDate, contract)
    .then(res => {
      response = res;
      if (res) dispatch(actionsForValidateMapping(key, 'ready', { ...response, productId }));
      else dispatch(actionsForUpdateMappingStatus(key, 'failed'));
    })
    .catch(err => {
      console.log(err.stack);
      dispatch(actionsForUpdateMappingStatus(key, 'failed', err.message));
    });
  };
}

export function getContract(contractID) {
  return dispatch => {
    dispatch({ type: constants.GET_CONTRACT_STARTING });
    return (soFetch(`/proxy/integration/contract/${contractID}`, {
      method: 'get',
      actionType: constants.GET_CONTRACT,
      responseBinding: 'integration',
    })(dispatch));
  };
}

export function clearExportState() {
  return { type: constants.CLEAR_EXPORT_STATE };
}

export function getContracts(payload = { page: 1 }) {
  return dispatch => {
    dispatch({ type: constants.GET_CONTRACTS_STARTING });
    return (soFetch(`/proxy/integration/contracts?page=${payload.page || 1}&sorKey=${
      payload.sortKey || ''
    }&sort=${
      payload.sort || ''
    }&searchInput=${
      payload.searchInput || ''
    }`, {
      method: 'get',
      actionType: constants.GET_CONTRACTS,
      responseBinding: 'integration',
    })(dispatch)).catch((err) => {
      console.log(err.stack);
      dispatch({ type: constants.GET_CONTRACTS_FAILED });
    });
  };
}

export function exportContract(contractWithMapping, convertedContract) {
  return dispatch => {
    dispatch({ type: '{integration-export} START' });

    return fetch('/integrationproxy/contractsJob', {
      method: 'post',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({
        // contractWithMapping: omit(['locationLogs'], contractWithMapping),
        contractId: contractWithMapping.contractId,
        contractWithMapping,
        convertedContract,
        callbackUrl: `${process.env.API_URL}/integration/saveExportResponse`,
        callbackHeaders: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('jwt')}`,
        },
      }),
    }).then(res => {
      if (res.status !== 200) throw new Error(res.status);
      return res.json();
    }).then(res => {
      return dispatch({
        type: '{integration-export} POLLING_ACTION_RESPONSE',
        payload: res,
      });
    }).catch(err => dispatch({ type: constants.ADD_MAPPING_FAILED, error: err.message }));
  };
}
export function sendHistoryFeedMsg(path, historyFeedId, message) {
  return dispatch => {
    dispatch({ type: constants.UPDATE_WITH_KEYPATH, payload: { keyPath: append('msgFlags', path), immutableValue: fromJS({ sendingMsg: true }) } });
    return fetch(`/proxy/contracting/saveComment/${historyFeedId}`, {
      method: 'put',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ message }),
    })
      .then(checkStatus)
      .then(() => dispatch({ type: constants.UPDATE_WITH_KEYPATH, payload: { keyPath: append('msgFlags', path), immutableValue: fromJS({ sendingMsg: false, msgSent: true }) } }))
      .catch(err => console.log(err));
  };
}
export function getAuth() {
  return dispatch => {
    return (soFetch('/proxy/integration/get-auth', {
      method: 'get',
      actionType: constants.GET_AUTH,
      responseBinding: 'auth',
    })(dispatch)).catch(err => dispatch({ type: constants.GET_AUTH_FAILED, payload: err }));
  };
}
export function updateWithKeyPath(keyPath, immutableValue) {
  return { type: constants.UPDATE_WITH_KEYPATH, payload: { keyPath, immutableValue } };
}

export function getConvertedContract(contractId, ratePackageIds) {
  return dispatch => {
    dispatch({ type: constants.GETTING_CONVERTED_CONTRACT });
    return fetch(`/integrationproxy/converted-contract/${contractId}?${queryString.stringify({
      ratePackageIds,
    })}`, {
      method: 'get',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
    })
      .then(checkStatus)
      .then(res => res.json())
      .then(res => dispatch({ type: constants.GET_CONVERTED_CONTRACT, payload: res }))
      .catch(err => {
        console.log('ERROR', err);
        dispatch({ type: constants.GETTING_CONVERTED_CONTRACT_FAILED });
      });
  }
}

export function login(userName, password, url) {
  return dispatch => {
    dispatch({ type: constants.LOGIN, payload: 'starting' });

    return fetch('/integrationproxy/user/login', {
      method: 'post',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({
        userName,
        password,
        url,
      }),
    }).then(res => {
      if (res.status !== 200) throw new Error(res.status);
      return res.json();
    }).then(() => {
      dispatch({ type: constants.LOGIN, payload: 'success' });
    }).catch(err => dispatch({ type: constants.LOGIN, payload: err.message }));
  };
}

export function markContractAsLoaded(contractId) {
  return dispatch => {
    dispatch({ type: '{TP_Integration}CHANGE_CONTRACT_STATE_STARTING' });
    return fetch('/proxy/contracting/updateContractStatus', {
      method: 'put',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({
        contractIds: [contractId],
        state: 'loaded',
      }),
    })
    .then(res => {
      if (res.status !== 200) throw new Error(res.status);
      return dispatch({ type: '{TP_Integration}CHANGE_CONTRACT_STATE_SUCCESS' });
    })
    .catch(err => {
      console.log(err);
      return dispatch({ type: '{TP_Integration}CHANGE_CONTRACT_STATE_ERROR' });
    });
  };
}



// WEBPACK FOOTER //
// ./src/app/stores/integration/integration-actions.js